import React, { Component } from 'react';
import { Brands , Hert } from '../../../../SvgIcon';
import { Link } from "react-router-dom";
import Sidebar from '../../../layout/Sidebar';
import Header from '../../../layout/Header';
import { Select } from 'antd';
import InlineError from "../../../../components/InlineError";
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import ReactDOM from 'react-dom'
import DropdownTreeSelect from 'react-dropdown-tree-select'
import 'react-dropdown-tree-select/dist/styles.css';
import { _Api } from '../../../../services/Api';
import Url from '../../../../services/BaseUrl';
import Cookies from 'js-cookie';
import { notify } from '../../../../components/Toaster';
import { Menu, Dropdown, TreeSelect, Modal, Tree  } from 'antd';
import {
    MyAlert,
    MySpinner
} from "../../../../components/index"
import { getDataAndFilter } from "../../../.././MyFilter";
import { validateEmail } from '../../../../components/Validation';
import util from '../../../../utils/Util.js';

const { SHOW_PARENT, SHOW_CHILD, SHOW_ALL } = TreeSelect;
let isEurop = { "BD": "AS", "BE": "EU", "BF": "AF", "BG": "EU", "BA": "EU", "BB": "NA", "WF": "OC", "BL": "NA", "BM": "NA", "BN": "AS", "BO": "SA", "BH": "AS", "BI": "AF", "BJ": "AF", "BT": "AS", "JM": "NA", "BV": "AN", "BW": "AF", "WS": "OC", "BQ": "NA", "BR": "SA", "BS": "NA", "JE": "EU", "BY": "EU", "BZ": "NA", "RU": "EU", "RW": "AF", "RS": "EU", "TL": "OC", "RE": "AF", "TM": "AS", "TJ": "AS", "RO": "EU", "TK": "OC", "GW": "AF", "GU": "OC", "GT": "NA", "GS": "AN", "GR": "EU", "GQ": "AF", "GP": "NA", "JP": "AS", "GY": "SA", "GG": "EU", "GF": "SA", "GE": "AS", "GD": "NA", "GB": "EU", "GA": "AF", "SV": "NA", "GN": "AF", "GM": "AF", "GL": "NA", "GI": "EU", "GH": "AF", "OM": "AS", "TN": "AF", "JO": "AS", "HR": "EU", "HT": "NA", "HU": "EU", "HK": "AS", "HN": "NA", "HM": "AN", "VE": "SA", "PR": "NA", "PS": "AS", "PW": "OC", "PT": "EU", "SJ": "EU", "PY": "SA", "IQ": "AS", "PA": "NA", "PF": "OC", "PG": "OC", "PE": "SA", "PK": "AS", "PH": "AS", "PN": "OC", "PL": "EU", "PM": "NA", "ZM": "AF", "EH": "AF", "EE": "EU", "EG": "AF", "ZA": "AF", "EC": "SA", "IT": "EU", "VN": "AS", "SB": "OC", "ET": "AF", "SO": "AF", "ZW": "AF", "SA": "AS", "ES": "EU", "ER": "AF", "ME": "EU", "MD": "EU", "MG": "AF", "MF": "NA", "MA": "AF", "MC": "EU", "UZ": "AS", "MM": "AS", "ML": "AF", "MO": "AS", "MN": "AS", "MH": "OC", "MK": "EU", "MU": "AF", "MT": "EU", "MW": "AF", "MV": "AS", "MQ": "NA", "MP": "OC", "MS": "NA", "MR": "AF", "IM": "EU", "UG": "AF", "TZ": "AF", "MY": "AS", "MX": "NA", "IL": "AS", "FR": "EU", "IO": "AS", "SH": "AF", "FI": "EU", "FJ": "OC", "FK": "SA", "FM": "OC", "FO": "EU", "NI": "NA", "NL": "EU", "NO": "EU", "NA": "AF", "VU": "OC", "NC": "OC", "NE": "AF", "NF": "OC", "NG": "AF", "NZ": "OC", "NP": "AS", "NR": "OC", "NU": "OC", "CK": "OC", "XK": "EU", "CI": "AF", "CH": "EU", "CO": "SA", "CN": "AS", "CM": "AF", "CL": "SA", "CC": "AS", "CA": "NA", "CG": "AF", "CF": "AF", "CD": "AF", "CZ": "EU", "CY": "EU", "CX": "AS", "CR": "NA", "CW": "NA", "CV": "AF", "CU": "NA", "SZ": "AF", "SY": "AS", "SX": "NA", "KG": "AS", "KE": "AF", "SS": "AF", "SR": "SA", "KI": "OC", "KH": "AS", "KN": "NA", "KM": "AF", "ST": "AF", "SK": "EU", "KR": "AS", "SI": "EU", "KP": "AS", "KW": "AS", "SN": "AF", "SM": "EU", "SL": "AF", "SC": "AF", "KZ": "AS", "KY": "NA", "SG": "AS", "SE": "EU", "SD": "AF", "DO": "NA", "DM": "NA", "DJ": "AF", "DK": "EU", "VG": "NA", "DE": "EU", "YE": "AS", "DZ": "AF", "US": "NA", "UY": "SA", "YT": "AF", "UM": "OC", "LB": "AS", "LC": "NA", "LA": "AS", "TV": "OC", "TW": "AS", "TT": "NA", "TR": "AS", "LK": "AS", "LI": "EU", "LV": "EU", "TO": "OC", "LT": "EU", "LU": "EU", "LR": "AF", "LS": "AF", "TH": "AS", "TF": "AN", "TG": "AF", "TD": "AF", "TC": "NA", "LY": "AF", "VA": "EU", "VC": "NA", "AE": "AS", "AD": "EU", "AG": "NA", "AF": "AS", "AI": "NA", "VI": "NA", "IS": "EU", "IR": "AS", "AM": "AS", "AL": "EU", "AO": "AF", "AQ": "AN", "AS": "OC", "AR": "SA", "AU": "OC", "AT": "EU", "AW": "NA", "IN": "AS", "AX": "EU", "AZ": "AS", "IE": "EU", "ID": "AS", "UA": "EU", "QA": "AS", "MZ": "AF" }

var _ = require('lodash');
const { SubMenu } = Menu;

let newaddress = ''


const data = {
    label: 'search me',
    value: 'searchme',
    children: [
        {
            label: 'search me too',
            value: 'searchmetoo',
            children: [
                {
                    label: 'No one can get me',
                    value: 'anonymous',
                },
            ],
        },
    ],
}






class AddBrand extends Component {
    constructor(props) {
        super(props);
        this.state = {
            companyName: '',
            companyNameError: '',
            cityError: '',
            city: '',
            countryError: '',
            country: '',
            countrycode: '',
            exhibitionId: '',
            plansId : '',
            email : '',
            placeOfWork: '',
            sectorId: '',
            roleId: '',

            postalCode: '',
            postalCodeError: '',
            phoneNumber: '',
            phoneNumberError: '',
            //placeOfWork: '',
            placeOfWorkError: '',
            jobTitle: '',
            sectorError:"",
            placeofWorkError:"",
            roleError:"",

            registrationIdError:"",
            jobTitleError: '',
            noOfPeopleWork: '',
            noOfPeopleWorkError: '',
            budget: '',
            productAndServiceError: '',
            productAndService: [],
            selectedSector:[],
            selectedPlaceOfWork:[],
            selectedRole:[],
            cityList:[],

            stateRole: '',
            stateRoleError: '',
            attandingLookingFor: [],
            attendingOrLookingfor: [],
            attandingLookingForError: '',
            display: false,
            countryAll: '',
            countryAllError: '',
            budgetError: '',
            type: '',
            selectBudget: '',
            selectBudgetError: '',
            profileStep: 1,
            signupStep: 1,
      isShowSignUpStep: true,
            stepStatus: 1,
            status: '',
            statusError: '',
            categoryAllData: '',
            dropDown1: [],
            dropDown2: [],
            dropDown3: [],
            dropDown4: [],
            dropDown5: [],
            dropDown6: [],
            isChecked: false,
            isLoader: false,
            test: 'werty',
            selectCountry:'',
            selectCity:'',
            disable: false,
            countryList: [],
            countryStateList: [],
            streetAddress1Error: '',
            streetAddress2Error: '',
            streetAddress1: '',
            streetAddress2: "",
            address: '',
            fullAddess: '',
            zip: "",
            AllData: '',
            isLoading: false,
            erroStatus: false,
            message: '',
            showMessage: false,
            sectorList:[],

            isEuropeCT: false,

            firstFill: false,

            exhibitionName: '',
            exhibitionNameError: '',
            formStatus: 1,
            formClass: 'status-process-step complete',
            buttonText: 'Next',
            brandStep: '1',
            //email: '',
            emailError: '',
            brandType: false,
            visible: false,
            placeOfWorkMobileTitle: '',
            noOfPeopleWorkMobile: '',
            jobTitleMobile: '',
            visible2: false,
            visible3: false,
            firstName:'', 
            lastName:''
        }
    }
    componentDidMount() {
        this.getSector();
    }

    checkSignupStepClass = (signupStep) => {
        if (signupStep < this.state.signupStep) {
          return "signup-step done";
        } else if (signupStep === this.state.signupStep) {
          return "signup-step active";
        } else {
          return "signup-step";
        }
      };
      getSector=()=>{
        _Api(Url.GET_SECTOR_LIST.method, Url.GET_SECTOR_LIST.url)
            .then(resp => {
                if (resp.statusCode == 1) {
                    this.setState({
                        sectorList: resp.responseData.result.data,
                    })
                }
            }).catch(err => {
            if (err.error)
                notify("err", err.error.responseMessage)
        })
    }


   
    getCountry=()=>{
        let self=this;
        //self.props.stateSet("isLoading",true)
        _Api(Url.GET_COUNTRY_LIST_V2.method, Url.GET_COUNTRY_LIST_V2.url)
            .then(resp => {
                if (resp.statusCode == 1) {
                    this.setState({
                        countryList: resp.responseData.result,
                        signupNext:5
                    })
                }
               // self.props.stateSet("isLoading",false)
            }).catch(err => {
            if (err.error)
                notify("err", err.error.responseMessage)
        })
    }
    signupNextStep=(e)=>{
        let self=this;
        e.preventDefault();
        if (self.state.signupStep == 1) {
            this.SignUpProcessProfileSubmit();

           
          }
        if(this.state.signupStep==2){
            if(this.state.selectedSector.length>0){
                self.getplaceOfWork(e);
            }else{
                this.setState({
                    sectorError:"*Please select any sector"
                })
            }
        }else if(this.state.signupStep==3){
            if(this.state.selectedPlaceOfWork.length>0) {
                self.getRole(e);
            }else{
                this.setState({
                    placeofWorkError:"*Please select any place of work"
                })
            }
        }else if(this.state.signupStep==4){
            if(this.state.selectedRole.length>0){
                this.setState({signupStep:5},()=> this.getCountry())
            }
            
            else{
                this.setState({
                    roleError:"*Please select any Role"
                })
            }
        
            // if(true){
            //     debugger;
            //     if(this.state.registrationId.trim()===""){
            //         this.setState({ registrationIdError: '*Please enter.' })
            //     }else{
            //         this.getCountry();
            //         this.state.signupNext(5);
            //     }
            // }
            // else {
            //     let checkRegistrationId = 0;
            //     if (this.props.selectedRole.length > 0) {
            //         let roleArr = ["5fc9d333611cf52928910101",
            //             "5fc73e5a237eae12638c982e",
            //             "5fc72577237eae12638c9823",
            //             "5fc72850237eae12638c9825",
            //             "5fc724ba237eae12638c9822",
            //             "5fc78d3c237eae12638c9834"];
            //         _.map(this.props.selectedRole, function (role) {
            //             let checkResult = _.find(roleArr, function (obj) {
            //                 return obj === role;
            //             })
            //             if (checkResult) {
            //                 checkRegistrationId++;
            //             }
            //         })

            //         if (checkRegistrationId > 0) {
            //             self.props.stateSet('registrationIdRequired',true)
            //         } else {
            //             this.getCountry();
            //             this.props.signupNext(5);
            //         }
            //     }
            //      else {
            //         this.setState({
            //             roleError: "*Please select any role"
            //         })
            //     }
            // }
        }else if(this.state.signupStep==5){
           
            if(!this.state.selectCountry){
                this.setState({ countryError: '*Please select country.' })
            }else if(!this.state.selectCity){
                this.setState({ cityError: '*Please select city.' })
            }else{
                // debugger;
                this.SignUpProcessWorkSubmit();
            }

        }
        else{
         


        }
    }
    signupBack=(e)=>{
        this.setState({
            signupStep: this.state.signupStep-1
        })
       
    }
    onChangeNoOfPeopleWork = (key, info) => {
        let { value, title } = info.node
        this.setState({
            noOfPeopleWorkId: value,
            visible2: false,
            noOfPeopleWorkMobile: title,
            attandingLookingForError: '',
            productAndServiceError: '',
            statusError: '',
            selectBudgetError: '',
            jobTitleError: '',
            noOfPeopleWorkError: '',
            budgetError: '',
            stateRoleError: ''
        }, function () {
            if (key === "jobTitleId") {
                if (value === "other") {
                    this.setState({ showChangeJobOther: true })
                } else {
                    this.setState({ showChangeJobOther: false })
                }
            }
        });
    }

    onChangeJobTitle = (key, info) => {
        let { value, title } = info.node
        this.setState({
            jobTitleId: value,
            visible3: false,
            jobTitleMobile: title,
            attandingLookingForError: '',
            productAndServiceError: '',
            statusError: '',
            selectBudgetError: '',
            jobTitleError: '',
            noOfPeopleWorkError: '',
            budgetError: '',
            stateRoleError: ''
        }, function () {
            if (key === "jobTitleId") {
                if (value === "other") {
                    this.setState({ showChangeJobOther: true })
                } else {
                    this.setState({ showChangeJobOther: false })
                }
            }
        });
    }




    handleOk = e => {
        console.log(e);
        this.setState({
            visible: false,
        });
    };

    handleCancel = e => {
        console.log(e);
        this.setState({
            visible: false,
            visible2: false,
            visible3: false
        });
    }

    handleChange = address => {
        this.setState({ address });
    };

    handleSelect = address => {
        this.setState({
            companyNameError: '',
            phoneNumberError: '',
            streetAddress1Error: '',
            cityError: '',
            countryError: '',
            postalCodeError: '',
        })

        geocodeByAddress(address)
            .then(results => {

                let data = results[0]?.address_components

                let cityArr = data.filter(item => item.types[0] == "country")[0]

                this.setState({ address: results[0]?.formatted_address })

                if (cityArr) {

                    this.setState({
                        country: cityArr.long_name,
                        // isEuropeCT: isEurop[cityArr.short_name] == "EU" 
                    })

                }
                return (
                    getLatLng(results[0]))
                    .then(latLng => {
                        address = address.split(',')


                        // this.setState({ lng: latLng.lng, lat: latLng.lat, address: address[0] })
                        this.setState({ lng: latLng.lng, lat: latLng.lat, })
                        // this.postalCode(latLng)

                        let Url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latLng.lat},${latLng.lng}&key=AIzaSyAjSodVOYLA8VVU2oOSToc7VtM8xKs13fI`

                        fetch(Url)
                            .then(response => response.json())
                            .then((result) => {
                                let zipcode;
                                let city;
                                let state;
                                let street;
                                let flag = true
                                for (var i = 0; i < result.results.length; i++) {
                                    for (var j = 0; j < result.results[i].address_components.length; j++) {
                                        for (var k = 0; k < result.results[i].address_components[j].types.length; k++) {
                                            if (result.results[i].address_components[j].types[k] == "route") {
                                                street = result.results[i].address_components[j].long_name;

                                                // this.setState({ zip: zipcode })
                                                if (street) {
                                                    this.setState({ street: street })
                                                }
                                                else {
                                                    this.setState({ street: '' })
                                                }

                                            }
                                            if (result.results[i].address_components[j].types[k] == "postal_code" && flag) {
                                                flag = false

                                                zipcode = result.results[i].address_components[j].long_name;

                                                if (zipcode) {
                                                    this.setState({ postalCode: zipcode })
                                                }
                                                else {
                                                    this.setState({ postalCode: '' })
                                                }

                                            }
                                            if (result.results[i].address_components[j].types[k] == "locality") {
                                                city = result.results[i].address_components[j].long_name;
                                                if (city) {
                                                    this.setState({ city: city })
                                                }
                                                else {
                                                    this.setState({ city: '' })
                                                }
                                            }
                                            if (result.results[i].address_components[j].types[k] == "administrative_area_level_1") {
                                                state = result.results[i].address_components[j].long_name;
                                                if (zipcode) {
                                                    this.setState({ state: state })
                                                }
                                                else {
                                                    this.setState({ state: '' })
                                                }

                                            }

                                        }
                                    }
                                }
                            })
                    }
                    )
            })
            .catch(error => { });

    }

    componentDidMount() {

        this.getCategory("1", "placeOfWorkData");
        this.getCategory("3", "productAndServiceOfferData");
        this.getCategory("5", "budgetData");
        this.getCategory("6", "noOfPeopleWorkData");

        if (Cookies.get('step') == undefined) {
        }
        else {
            this.setState({ ...JSON.parse(Cookies.get('step')), ...JSON.parse(Cookies.get('step0')) })
        }

    }
    getCategory = (categoryType, keyName) => {
        let params = {
            categoryType: categoryType,
        }
        _Api(Url.GET_CATEGORY_LIST.method, Url.GET_CATEGORY_LIST.url, params)
            .then(resp => {
                //console.log('responseData', resp.responseData);
                let keyNameData = resp.responseData.result.map((item1, index1) => {
                    let childData = item1.subCategory.map((data, index2) => {
                        let ddd = {
                            title: data.categoryTitle,
                            value: data._id,
                            children: []
                        }
                        return ddd
                    })
                    //console.log("childData",childData)
                    let dd = {
                        selectable: childData.length > 0 ? false : true,
                        title: childData.length > 0 ? <b style={{ color: '#000' }}>{item1.categoryTitle}</b> : item1.categoryTitle,
                        value: item1._id,
                        checkable: childData.length > 0 ? false : true,
                        children: childData
                    }
                    return dd
                })
                if (keyName === "placeOfWorkData" || keyName === "jobTitleData") {
                    keyNameData.push({
                        title: 'Other',
                        value: 'other',
                        children: []
                    })
                }
                this.setState({
                    [keyName]: keyNameData
                })
            }).catch(err => {
                this.setState({ isLoader: false })
                if (err.error)
                    notify("err", err.error.responseMessage)
               // else if (err)
                //     // notify("err", err.message)
                this.setState({ isLoader: false })
            })
    }

    // on change
    signupProcessOnChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            firstNameError: '',attandingLookingForError: '', emailError: '', productAndServiceError: '', companyNameError: '', countryAllError: '', cityError: '', countryError: '', streetAddress1Error: '', streetAddress2Error: '', postalCodeError: '', phoneNumberError: '',placeOfWorkError:'',
        })
    }

    selectOnChange = (type, e) => {
        this.setState({
            [type]: e, placeOfWorkError: '',
            attandingLookingForError: '', productAndServiceError: '', statusError: '', selectBudgetError: '', jobTitleError: '', noOfPeopleWorkError: '', budgetError: '', stateRoleError: '',
        })
    }

    //sign up process submit
    SignUpProcessProfileSubmit = () => {
        this.setState({
            companyNameError: '',
            phoneNumberError: '',
            streetAddress1Error: '',
            cityError: '',
            countryError: '',
            postalCodeError: '',
        })
        let rexx = /^(?:(?:\+|0{0,2})91(\s*[\ -]\s*)?|[0]?)?[789]\d{9}|(\d[ -]?){7,15}\d$/
        let {firstName, companyName, state, email, city, contactName, countryAll, country, postalCode, phoneNumber, streetAddress1, address } = this.state
        if (!firstName)
            this.setState({ firstNameError: '*Please enter first name' })
        else if (email === '')
            this.setState({ emailError: '*Please enter email.' })
        else if (!validateEmail(email).status)
            this.setState({ emailError: '*Please enter valid email.' })
        // else if (companyName === '')
        //     this.setState({ companyNameError: '*Please enter company name.' })
        else if (phoneNumber === '')
            this.setState({ phoneNumberError: '*Please enter phone number.' })
            else if (!rexx.test(phoneNumber))
            this.setState({ phoneNumberError: '*Please enter valid phone number.' })
        else if (city === '')
            this.setState({ cityError: '*Please enter city.' })
        else if (country === '')
            this.setState({ countryError: '*Please enter country.' })
        else {
            this.setState({ signupStep: 2 },()=> this.getSector())
           
        }
    }
    SignUpProcessWorkSubmit = () => {
        // debugger;
       
        //
       
        let {
            firstName, 
            lastName,
            brandType,
            placeOfWorkId,  
            countrycode,
            exhibitionId,
            phoneNumber,
            plansId ,
            email ,
            placeOfWork,
            sectorId,
            companyName,
            roleId, address,streetAddress2,postalCode,jobTitleOther,placeOfWorkOther,country,city,noOfPeopleWorkId, productAndServiceOfferId, attendingOrLookingforId, budgetId
        } = this.state
       
        // debugger;

            let req2 = {
                userType: 2,
                planId: brandType ? 3 : 2,
                exhibitionId: this.props?.match?.params?.exId,
                email: email,
                // productAndServiceOfferId: this.state.productAndServiceOfferId.toString(),
                // attendingOrLookingforId: this.state.attendingOrLookingforId.toString(),
                // budgetId: budgetId,
                phoneNo: phoneNumber,
                companyName: companyName,
                streetAddress1: address,
                streetAddress2: streetAddress2,
                zipCode: postalCode,
                country: this.state.selectCountry,
                country_Code :countrycode,
                //exhibitionId:exhibitionId,
                city: city,
                //planId : plansId,
                //email : email,
                placeOfWork: this.state.selectedPlaceOfWork,
                sectorId: this.state.selectedSector,
                roleId: this.state.selectedRole,
                placeOfWorkOther: placeOfWorkOther,
                jobTitleOther: jobTitleOther,
                firstName: firstName,
                lastName: lastName,
                // isEuropean: this.state.isEuropeCT == true ? 1 : 0
            }

           

            _Api(Url.ADD_USER.method, Url.ADD_USER.url, req2)
                .then(resp => {
                    notify('success', resp.responseData.message)
                    this.setState({ isLoader: false })
                    // localStorage.setItem("accessToken", resp.responseData.accessToken)
                    // localStorage.setItem("isLoggedIn", "true")
                    Cookies.remove('step0');
                    Cookies.remove('step');
                    this.props.history.goBack()
                }).catch(err => {
                    // debugger;
                    this.setState({ isLoader: false })
                    if (err.error)
                        notify("err", err.error.responseMessage)
                   else if (err)
                   notify("err", err.message)
                })
        
    
}

    handleStep = (step) => {
        if (this.state.firstFill)
            this.setState({ profileStep: step })
    }

    onChangeSelect = (key, value) => {
        this.setState({
            [key]: value,
            attandingLookingForError: '',
            productAndServiceError: '',
            statusError: '',
            selectBudgetError: '',
            jobTitleError: '',
            noOfPeopleWorkError: '',
            budgetError: '',
            stateRoleError: ''
        }, function () {
            if (key === "jobTitleId") {
                if (value === "other") {
                    this.setState({ showChangeJobOther: true })
                } else {
                    this.setState({ showChangeJobOther: false })
                }
            }
        });
    }
    checkSelected=(field,value)=>{
        let selectedField=this.props[field]
        let checkResult=_.find(selectedField,function (obj){
            return obj===value;
        })
        //console.log("selectedField",selectedField,checkResult,value)
        if(checkResult){
            return true;
        }else{
            return false;
        }
    }
    getplaceOfWork=(e)=>{
        let self=this;
        e.preventDefault();
        let sectorId=this.state.selectedSector;
       
        _Api(Url.GET_PLACE_OF_WORK_LIST.method, Url.GET_PLACE_OF_WORK_LIST.url,{sectorId:sectorId.toString()})
            .then(resp => {
                if (resp.statusCode == 1) {
                    this.setState({
                        placeOfWorkList: resp.responseData.result.data,
                        signupStep:3
                    })
                  
                   
                }
            }).catch(err => {
            if (err.error)
                notify("err", err.error.responseMessage)
        })

    }

    getRole=(e)=>{
        let self=this;
        e.preventDefault();
        let placeOfWorkId=this.state.selectedPlaceOfWork;
            _Api(Url.GET_ROLE_LIST.method, Url.GET_ROLE_LIST.url, {placeOfWorkId: placeOfWorkId.toString()})
                .then(resp => {
                    if (resp.statusCode == 1) {
                        this.setState({
                            roleList: resp.responseData.result.data,
                            signupStep:4
                        })
                    }
                }).catch(err => {
                if (err.error)
                    notify("err", err.error.responseMessage)
            })
    }


    selectCountry=(value)=>{
        let data=value.split("#");
        this.setState({selectCountry: (data[0],data[1])},()=>this.getCity(data[0]));
        
    }

    selectCity=(value)=>{
        let data=value.split("#");
        this.setState({selectCity:(data[1],data[0])})

    }
    onChecked=(e,field,countField)=>{
        let selectedField=this.state[field]
        if(field==='selectedSector'){
            this.setState({
                selectedPlaceOfWork:[],
                placeofworkCount:0,
                selectedRole:[],
                roleCount:0,
                registrationId:"",
                registrationIdRequired:false,
            })
        }else if(field==='selectedPlaceOfWork'){
            this.setState({
                selectedRole:[],
                roleCount:0,
                registrationId:"",
                registrationIdRequired:false,
            })
        }else if(field==='selectedRole'){
            this.setState({
                registrationId:"",
                registrationIdRequired:false,
            })
        }
        let checkResult=_.find(selectedField,function (obj){
            return obj===e.target.value;
        })
        //console.log("onChecked",e.target.value,selectedField,checkResult);
        if(checkResult){
            let newData = _.remove(selectedField, function(n) {
                return e.target.value===n;
            });
            //console.log("======",newData);
            this.setState({
                [field]:selectedField,
                [countField]:this.state[countField]-1
            })
        }else {
            selectedField.push(e.target.value);
            this.setState({
                [field]:selectedField,
                [countField]:this.state[countField]+1
            })
        }
    }
    getCity=(selectedCountryCode)=>{
        let self=this;
        //let selectedCountryCode=this.props.selectedCountryCode;
        _Api(Url.GET_CITY_LIST.method, Url.GET_CITY_LIST.url,'', '?countryCode='+selectedCountryCode)
            .then(resp => {
                if (resp.statusCode == 1) {
                    this.setState({
                        cityList: resp.responseData.result,
                    })
                }
            }).catch(err => {
            if (err.error)
                notify("err", err.error.responseMessage)
        })
    }

    render() {
        // console.log("fkjdshgvbfhjisdhfh", this.state.jobTitleError, this.state.placeOfWorkId)
        let { stepStatus, categoryAllData, isLoader, streetAddress1, streetAddress2, streetAddress2Error, streetAddress1Error,
            country, countryAllError, countryAll, countryError, stateError, cityError, companyName, profileStep, city, address,
            contactName, postalCode, phoneNumber, companyNameError, postalCodeError, streetAddress, streetAddressError, type,
            contactNameError, phoneNumberError, placeOfWork, jobTitle, jobTitleError, noOfPeopleWork, noOfPeopleWorkError, placeOfWorkError,
            state, budget, budgetError, productAndService, selectBudgetError, selectBudget, productAndServiceError, stateRole, stateRoleError, attandingLookingFor, attandingLookingForError
            , statusError, status, formClass, email, emailError,registrationId,
            lastNameError, firstNameError, firstName, lastName,sectorError,laceofWorkError,roleError,registrationIdError,placeofWorkError
        } = this.state


        const tProps = {
            treeData: this.state.dropDown2,
            value: this.state.productAndService,
            onChange: this.onChange,
            treeCheckable: true,
            showCheckedStrategy: SHOW_PARENT,
            placeholder: 'Please select',
            style: {
                width: '100%',
                border: 'none'
            },
        };
        

        const tProps2 = {
            treeData: this.state.dropDown2,
            value: this.state.attendingOrLookingfor,
            onChange: this.onChange2,
            treeCheckable: true,
            showCheckedStrategy: SHOW_PARENT,
            placeholder: 'Please select',
            style: {
                width: '100%',
            },
        };
       




        const { Option } = Select;
        
        return (
            <>
                <div className="dash_body_container">
                    <div className="body_container">
                        <div className="header-text  mb-4 mt-3">
                            <div className="d-flex align-items-center">
                                <p className="header-icon"><Brands /></p>
                                <h4>Add Brand
                                    <br />
                                    {/* <ul className="header-breadcrum">
                                        <li><a href="#">Exhibition Management</a>/</li>
                                        <li><a href="#">Exhibition Detail</a></li>
                                    </ul> */}
                                </h4></div>

                            <a > <button onClick={() => this.props.history.goBack()} className="btn btn-light"><i class="fa fa-arrow-left" aria-hidden="true"></i>Back</button></a>
                        </div>
                        <div className="rounded-body-form mt-2">

                             <div className="signup-tab mt-5">
                                    <div className="Thing-line">
                                        <span className="circle_bullet"></span>
                                        <span className="heart">
                                        <Hert />
                                        </span>
                                    </div>
                                    <div className={this.checkSignupStepClass(1)}>
                                        <span>1</span>
                                    </div>
                                    <div className={this.checkSignupStepClass(2)}>
                                        <span>2</span>
                                    </div>
                                    <div className={this.checkSignupStepClass(3)}>
                                        <span>3</span>
                                    </div>
                                    <div className={this.checkSignupStepClass(4)}>
                                        <span>4</span>
                                    </div>
                                    <div className={this.checkSignupStepClass(5)}>
                                        <span>5</span>
                                    </div>

                              </div>
                            <div className="">
                                {/* {isLoader && <Loader />} */}
                                {this.state.signupStep===1 &&
                                    <div className="profile">
                                        <div className="rounded-textbox-form mt-5 w-100" >

                                            <div className="row">

                                                <div className="col-md-6">
                                                    <div className="form-group">

                                                    <label>First name</label>
                                                    <input type="text"
                                                        autoComplete="new-password"
                                                        className="form-control"
                                                        placeholder="First name "
                                                        id="firstName"
                                                        maxLength={64}
                                                        name='firstName'
                                                        value={firstName}
                                                        onChange={this.signupProcessOnChange}
                                                    />
                                                    <InlineError
                                                        message={firstNameError}
                                                    />

                                                    <label>Last name</label>
                                                    <input type="text"
                                                        autoComplete="new-password"
                                                        className="form-control"
                                                        placeholder="Last name"
                                                        id="lastName"
                                                        maxLength={64}
                                                        name='lastName'
                                                        value={lastName}
                                                        onChange={this.signupProcessOnChange}
                                                    />
                                                    <InlineError
                                                        message={lastNameError}
                                                    />
                                                      <label>Email</label>
                                                        <input type="email"
                                                            autoComplete="new-password"
                                                            className="form-control"
                                                            placeholder="Email "
                                                            id="email"
                                                            maxLength={64}
                                                            name='email'
                                                            value={email}
                                                            onChange={this.signupProcessOnChange}
                                                        />
                                                        <InlineError
                                                            message={emailError}
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label>Company name</label>
                                                        <input type="text"
                                                            autoComplete="new-password"
                                                            className="form-control"
                                                            placeholder="Company name "
                                                            id="email"
                                                            maxLength={64}
                                                            name='companyName'
                                                            value={companyName}
                                                            onChange={this.signupProcessOnChange}
                                                        />
                                                        <InlineError
                                                            message={companyNameError}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Phone number</label>
                                                        <PhoneInput
                                                            country={'ae'}
                                                            placeholder="Phone number"
                                                            enableLongNumbers="false"
                                                            autoFormat="false"
                                                            value={this.state.phoneNumber}
                                                            onChange={phoneNumber => this.setState({ phoneNumber, phoneNumberError: '' })}
                                                        />
                                                        <InlineError
                                                            message={phoneNumberError}
                                                        />
                                                    </div>
                                                    {/* <div className="form-group">
                                                        <label>Street address 1 </label>

                                                        <PlacesAutocomplete
                                                            value={this.state.address}
                                                            onChange={this.handleChange}
                                                            onSelect={this.handleSelect}
                                                        >
                                                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                                <div className=''>
                                                                    <input
                                                                        autocomplete="do-not-show-ac"
                                                                        value={address}
                                                                        {...getInputProps({

                                                                            placeholder: 'Search address',
                                                                            className: 'form-control',
                                                                        })}
                                                                    />
                                                                    <div className="autocomplete-dropdown-container">
                                                                        {loading && <div>Loading...</div>}
                                                                        {suggestions.map((suggestion, i) => {
                                                                            const className = suggestion.active
                                                                                ? 'suggestion-item--active'
                                                                                : 'suggestion-item';
                                                                            // inline style for demonstration purpose
                                                                            const style = suggestion.active
                                                                                ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                                                                : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                                                            return (
                                                                                <div
                                                                                    key={i + "-add"}
                                                                                    {...getSuggestionItemProps(suggestion, {
                                                                                        className,
                                                                                        style,
                                                                                    })}
                                                                                >
                                                                                    <span>{suggestion.description}</span>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </PlacesAutocomplete>

                                                        <InlineError
                                                            message={streetAddress1Error}
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label>Street address 2</label>
                                                        <input type="text"
                                                            autocomplete="do-not-show-ac"
                                                            className="form-control"
                                                            placeholder="Landmark / Locality"
                                                            id="email"
                                                            maxLength={200}
                                                            name='streetAddress2'
                                                            value={streetAddress2}
                                                            onChange={this.signupProcessOnChange}
                                                        />
                                                        <InlineError
                                                            message={streetAddress2Error}
                                                        />
                                                    </div>
                                                 */}
                                                </div>


                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <level>Brand Type</level>
                                                        <div className="assign-checkboc-parent">
                                                            <div>
                                                                <label className="cm_container">
                                                                    Brand showcase
                                                                    <input checked={!this.state.brandType} onClick={() => this.setState({ brandType: !this.state.brandType })} type="radio" name="radio" />
                                                                    <span className="radio-checkmark"></span>
                                                                </label>
                                                            </div>
                                                            <div>
                                                                <label className="cm_container">
                                                                    Premium brand showcase
                                                                    <input checked={this.state.brandType} onClick={() => this.setState({ brandType: !this.state.brandType })} type="radio" name="radio" />
                                                                    <span className="radio-checkmark"></span>
                                                                </label>
                                                            </div>
                                                        </div>                                                     


                                                    </div>

                                                    <div className="form-group">
                                                        <label>City</label>
                                                        <input type="text"
                                                            autocomplete="do-not-show-ac"
                                                            className="form-control"
                                                            placeholder="City"
                                                            id="email"
                                                            maxLength={200}
                                                            name='city'
                                                            value={this.state.city}
                                                            onChange={this.signupProcessOnChange}
                                                        />
                                                        <InlineError
                                                            message={cityError}
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <div className="form-group">
                                                            <label>Country</label>
                                                            <Select showSearch autoComplete="new-password" placeholder="Country" value={this.state.country ? this.state.country : null}
                                                                onChange={(e) => this.selectOnChange("country", e)} name='country'
                                                                filterOption={(input, option) =>
                                                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) === 0
                                                                }
                                                            >
                                                                {util.countryOtption.map((item) => {
                                                                return (<Option value={item.displayValue}>{item.displayValue}</Option>)
                                                            })}
                                                               
                                                            </Select>
                                                            <InlineError message={countryError}/>
                                                        </div>
                                                    </div>

                                                    {/* <div className="form-group">
                                                        <label>Zip / Postal code</label>
                                                        <input type="text"
                                                            autocomplete="do-not-show-ac"
                                                            className="form-control"
                                                            placeholder="Zip / Postal code "
                                                            id="email" autoComplete="off"
                                                            maxLength={10}
                                                            name='postalCode'
                                                            value={postalCode}
                                                            onChange={this.signupProcessOnChange}
                                                        />
                                                        <InlineError
                                                            message={postalCodeError}
                                                        />

                                                    </div> */}
                                                    {/* <div className="text-center">
                                                        <button type="submit" disabled={this.props.isLoading}  className="btn btn-red"> &nbsp;Next
                                                            &nbsp;
                                                        {this.state.isLoading &&
                                                                <MySpinner
                                                                />}
                                                        </button>
                                                    </div> */}
                                                    <div className="form-group">
                                                        <button type="button" onClick={this.signupNextStep} className="btn btn-red btn-block btn-label">Submit</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            {this.state.signupStep===2?
                            <div id="step1" >
                                <h3 className="auth-heading pos-relative text-center mt-5">
                                What Sector(s) do you work in?
                                <span className="heading-after-border heading-after-border-center"><span className="heart"><Hert /></span></span>
                               </h3>
                                {/*<p className="home-subheading text-center">Free for professionals and low cost options for brands and suppliers </p>*/}
                                <form className="rounded-textbox-form mt-5" onSubmit={this.signupNextStep}>

                                    {this.state.sectorList.length>0&&this.state.sectorList.map((item) => (
                                        <div className={this.checkSelected('selectedSector',item._id)?"form-group form-control select_field":"form-group form-control"} key={item._id}>
                                            <div className="check_wrapper circle-checkbox ">
                                                <input name={'selectedSector-'+item.name} onChange={()=> this.checkSelected('selectedSector',item._id)} type="checkbox" value={item._id} onChange={(e)=>this.onChecked(e,'selectedSector','selectedSectorCount')}/>
                                                <span />
                                            </div>
                                            <span>{item.name}</span>
                                        </div>
                                    ))}
                                    <InlineError
                                        message={sectorError}/>
                                        <div class="row">
                                             <div class="col-sm-6">
                                                 <div class="">
                                                 <button type="submit" disabled={this.props.isLoading}  onClick={(e) =>this.signupBack()} className="btn btn-red"> &nbsp;Back
                                            &nbsp;
                                        {this.state.isLoading &&
                                                <MySpinner
                                                />}
                                        </button>
                                                 </div>
                                             </div>
                                             <div class="col-sm-6">
                                                 <div class="text-right">
                                                 <button type="submit" disabled={this.props.isLoading}  className="btn btn-red"> &nbsp;Next
                                            &nbsp;
                                        {this.state.isLoading &&
                                                <MySpinner
                                                />}
                                        </button>
                                                 </div>
                                             </div>
                                        </div>
                              
                                </form>
                            </div>
                            :""}
                            {this.state.signupStep===3?
                            <div id="step2" >
                            <h3 className="auth-heading pos-relative text-center mt-5">
                                What is your place of work?
                                <span className="heading-after-border heading-after-border-center"><span className="heart"><Hert /></span></span>
                               </h3>
                                {/*<p className="home-subheading text-center">Free for professionals and low cost options for brands and suppliers </p>*/}
                                <form className="rounded-textbox-form mt-5" onSubmit={this.signupNextStep}>
                                    {this.state.placeOfWorkList.length>0&&this.state.placeOfWorkList.map((item) => (
                                        <div className={this.checkSelected('selectedPlaceOfWork',item._id)?"form-group form-control select_field":"form-group form-control"} key={item._id}>
                                            <div className="check_wrapper circle-checkbox ">
                                                <input name={'selectedPlaceOfWork-'+item.name} type="checkbox" value={item._id} onChange={(e)=>this.onChecked(e,'selectedPlaceOfWork','placeofworkCount')}/>
                                                <span />
                                            </div>
                                            <span>{item.name}</span>
                                        </div>
                                    ))}
                                    <InlineError
                                        message={placeofWorkError}/>
                                        <div class="row">
                                             <div class="col-sm-6">
                                                 <div class="">
                                                 <button type="submit" disabled={this.props.isLoading}  onClick={this.props.signupBack} className="btn btn-red"> &nbsp;Back
                                                    &nbsp;
                                                {this.state.isLoading &&
                                                        <MySpinner
                                                        />}
                                        </button>

                                                 </div>
                                             </div>
                                             <div class="col-sm-6">
                                                 <div class="text-right">
                                                     <button type="submit"  disabled={this.props.isLoading} className="btn btn-red"> &nbsp;Next
                                                        &nbsp;
                                                    {this.state.isLoading &&
                                                            <MySpinner
                                                            />}
                                                    </button>
                                                     
                                                 </div>
                                             </div>
                                        </div>
                               
                                </form>
                            </div>
                            :""}
                            {this.state.signupStep===4?
                               true?
                            <div id="step3" >
                            <h3 className="auth-heading pos-relative text-center mt-5">
                                What is your role?
                                <span className="heading-after-border heading-after-border-center"><span className="heart"><Hert /></span></span>
                               </h3>
                                {/*<p className="home-subheading text-center">Free for professionals and low cost options for brands and suppliers </p>*/}
                                <form className="rounded-textbox-form mt-5" onSubmit={this.signupNextStep}>
                                    {this.state.roleList.length>0&&this.state.roleList.map((item) => (
                                        <div className={this.checkSelected('selectedRole',item._id)?"form-group form-control select_field":"form-group form-control"} key={item._id}>
                                            <div className="check_wrapper circle-checkbox ">
                                                <input name={'selectedRole-'+item.name}  type="checkbox" value={item._id} onChange={(e)=>this.onChecked(e,'selectedRole','roleCount')}/>
                                                <span />
                                            </div>
                                            <span>{item.name}</span>
                                        </div>
                                    ))}
                                    <InlineError
                                        message={roleError}/>
                                        <div class="row">
                                             <div class="col-sm-6">
                                                 <div class="">
                                                 <button type="submit" disabled={this.props.isLoading}  onClick={(e) =>this.signupBack()} className="btn btn-red"> &nbsp;Back
                                                    &nbsp;
                                                {this.state.isLoading &&
                                                        <MySpinner
                                                        />}
                                                </button>
                                                 </div>
                                             </div>
                                             <div class="col-sm-6">
                                                 <div class="text-right"><button type="submit" disabled={this.props.isLoading} className="btn btn-red"> &nbsp;Next
                                                    &nbsp;
                                                {this.state.isLoading &&
                                                        <MySpinner
                                                        />}
                                                </button>
                                                     
                                                 </div>
                                             </div>
                                        </div>
                                   

                                </form>
                            </div>

                            :

                                <div className="mt-5">
                                    <h4 className="pl-4 pr-4">Do you have a registered GDC/ GMC/ NMC/ GPhc number or overseas equivalent?</h4>
                                    <form className="rounded-textbox-form mt-5" onSubmit={this.signupNextStep}>
                                        <div className="form-group">
                                            <input type="text"
                                                   autocomplete="do-not-show-ac"
                                                   className="form-control"
                                                   placeholder="Enter GDC/ GMC/ NMC/ GPhc number"
                                                   name='registrationId'
                                                   value={registrationId}
                                                   onChange={this.props.sugnUpOnChange}
                                            />
                                            <InlineError
                                                message={registrationIdError}/>
                                        </div>
                                        <div class="row">
                                             <div class="col-sm-6">
                                                 <div class="">
                                                 <button type="submit" disabled={this.props.isLoading}  onClick={(e) =>this.signupBack()} className="btn btn-red"> &nbsp;Back
                                                &nbsp;
                                            {this.state.isLoading &&
                                                    <MySpinner
                                                    />}
                                            </button>
                                                 </div>
                                             </div>
                                             <div class="col-sm-6">
                                                 <div class="text-right"> 
                                                 <button type="submit"  disabled={this.props.isLoading} className="btn btn-red"> &nbsp;Next
                                                &nbsp;
                                                {this.state.isLoading &&
                                                <MySpinner
                                                />}
                                            </button>
                                                
                                                     
                                                 </div>
                                             </div>
                                        </div>
                                       
                                    </form>
                                </div>
                               
                               :""}

                            {this.state.signupStep===5?
                             <div id="step4" >
                                <form className="rounded-textbox-form mt-5 " onSubmit={this.signupNextStep}>
                                    <div className="form-group">
                                        <h4 className="text-center"><b>Which country you are based in?</b>
                                            {/* <span className="red-star"> * </span> */}
                                        </h4>
                                        <Select showSearch
                                         placeholder="Select Country" onChange={(e)=>this.selectCountry(e)}
                                         >
                                            {this.state.countryList.length>0&&this.state.countryList.map((item) => (
                                                <Option key={item.country_code} value={item.country_code+"#"+item.country_name}>{item.country_name}</Option>
                                                ))}
                                        </Select>
                                        <InlineError
                                            message={countryError}/>
                                    </div>
                                    <div className="form-group">
                                        <h4 className="text-center"><b>What is your closest large city?</b>
                                            {/* <span className="red-star"> * </span> */}
                                        </h4>
                                        <Select showSearch
                                         placeholder="Select City"
                                                onChange={(e)=>this.selectCity(e)}
                                         >
                                            {this.state.cityList.length>0&&this.state.cityList.map((item) => (
                                                <Option key={item._id} value={item._id+"#"+item.city_name}>{item.city_name}</Option>
                                            ))}

                                        </Select>
                                        <InlineError
                                            message={cityError}/>
                                    </div>
                                    <div class="row">
                                             <div class="col-sm-6">
                                                 <div class="">
                                                 <button type="submit" disabled={this.props.isLoading}  onClick={(e) =>this.signupBack()} className="btn btn-red"> &nbsp;Back
                                                    &nbsp;
                                                {this.state.isLoading &&
                                                        <MySpinner
                                                        />}
                                                </button>
                                                 </div>
                                             </div>
                                             <div class="col-sm-6">
                                                 <div class="text-right">
                                                 <button type="submit" disabled={this.props.isLoading} className="btn btn-red" onClick={(e) =>this.SignUpProcessWorkSubmit()}> &nbsp;Next
                                                    &nbsp;
                                                {this.state.isLoading &&
                                                        <MySpinner
                                                        />}
                                                </button>
                                                 </div>
                                             </div>
                                        </div>
                                  

                                </form>

                            </div> :""}

                            </div>

                        </div>

                    </div>
                </div>
                </>
        );
    }
}
export default AddBrand;




